module.exports = __webpack_public_path__ + "img/Warehouse02E.5d0dd496.jpg";